import { List, Space, Tag } from "antd";
import { CardBatch } from "models/cards";
import { BatchType, BatchTypeNames } from "models/packages";
import { localizedDate } from "util/helpers";
import EditBatchModal from "./EditBatchModal";

export const BatchTitle = ({ number, type }: CardBatch) => {
    let color = undefined;

    if (type === BatchType.Legacy) {
        color = "magenta"
    } else if (type === BatchType.Scannable) {
        color = "green"
    } else if (type === BatchType.NonScannable) {
        color = "cyan"
    }

    return <Space>
        {number}
        <Tag color={color}> {BatchTypeNames[type]}</Tag>
    </Space>
}

const BatchTable = (props: { batches: CardBatch[], onSuccess: () => Promise<void> }) => {
    return <List
        size="small"
        style={{ marginLeft: '2%' }}
        rowKey={b => b.id}
        itemLayout="horizontal"
        dataSource={props.batches}
        renderItem={item => (
            <List.Item>
                <List.Item.Meta
                    avatar={<EditBatchModal batch={item} onSuccess={props.onSuccess} />}
                    title={<BatchTitle {...item} />}
                    description={localizedDate(item.createdDate)}
                />
            </List.Item>
        )} />
}

export default BatchTable;